import { render, staticRenderFns } from "./UserInvoicesWin.vue?vue&type=template&id=10ef373d&"
import script from "./UserInvoicesWin.vue?vue&type=script&lang=js&"
export * from "./UserInvoicesWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports